import { useParams, useLocation } from "react-router-dom";
const defaultDB = "oxford";

export function GetDBNameFromParams() {
    const { dbName } = useParams();
    return dbName || defaultDB;
}